import Home from '@/views/Home/indexHome';
import Userinfo from '@/views/User/userinfoIndex';
//import Vehicle from '@/views/Vehicle/vehicleIndex'
//import Addnew from '@/views/Vehicle/addnewIndex'
import SearchChetou from '@/views/Public/searchChetouIndex';
import SearchChegua from '@/views/Public/searchCheguaIndex';
import RedictPlatform from '@/pages/Public/redictPlatform.vue';
import Orderlist from '@/views/Order/orderlistIndex';
import Orderdetail from '@/views/Order/orderdetailIndex';
import AppointmentIndex from '@/views/Appointment/appointmentIndex';
//import ChooseTime from './../views/Appointment/chooseTime'
import UserProtocol from '@/views/User/userprotocolIndex';
import UserProtocol2 from '@/views/User/userprotocol2Index';
import AppointmentxhIndex from '@/views/Appointmentxh/appointmentxhIndex';
import Appointmentxy from '@/views/Public/appointmentxyIndex';
import Uploadth from '@/views/Public/uploadthIndex';
import Travelupload from '@/views/Public/traveluploadIndex';
//new
import Mine from '@/views/User/mineIndex';
import DriverList from '@/views/Driver/driverList';
import AddDriver from '@/views/Driver/addDriver';
import DriverDetail from '@/views/Driver/driverDetail';
import EditDriver from '@/views/Driver/editDriver';

import EscortList from '@/views/Escort/escortList';
import AddEscort from '@/views/Escort/addEscort';
import EscortDetail from '@/views/Escort/escortDetail';
import EditEscort from '@/views/Escort/editEscort';

import ChetouList from '@/views/Vehicle/chetouList';
import Addchetou from '@/views/Vehicle/addChetou';
import EditChetou from '@/views/Vehicle/editChetouNew';
import ChetouDetail from '@/views/Vehicle/chetouDetail';

import CeguaList from '@/views/Vehicle/cheguaList';
import Addchegua from '@/views/Vehicle/addChegua';
import CheguaDetail from '@/views/Vehicle/cheguaDetail';
import EditChegua from '@/views/Vehicle/editChegua';

import UploadHealthCode from '@/views/Public/uploadHealthCode';
import UploadPound from '@/views/Public/uploadPound';

import InputYyNumber from '@/views/Public/inputYyNumber';
import InputYyNumberOld from '@/views/Public/inputYyNumberOld';
import AppointmentxhIndexNew from '@/views/Appiontmentnew/appointmentxhIndexNew';
import AppointmentIndexNew from '@/views/Appiontmentnew/appointmentIndexNew';
import ChoiceYy from '@/views/Appiontmentnewbak/choiceThyy';

import ClearCache from '@/views/other/clearCache.vue';
import AIChatIndex from '@/views/AIChat/AIChatIndex';

const router = [
  {
    path: '/', //路径
    name: 'index',
    component: Home, //组件
    meta: {
      title: '槽车在线预约入库平台',
    },
  },
  {
    path: '/Userinfo',
    name: 'userinfo',
    component: Userinfo,
    meta: {
      // 页面标题title
      title: '用户信息',
    },
  },

  {
    path: '/Public',
    name: 'searchChetou',
    component: SearchChetou,
    meta: {
      title: '搜索车头号',
    },
  },
  {
    path: '/Public',
    name: 'searchChegua',
    component: SearchChegua,
    meta: {
      title: '搜索车挂号',
    },
  },
  {
    path: '/cczxsc',
    name: 'cczxsc',
    component: RedictPlatform,
    meta: {
      title: '中转平台',
    },
  },
  {
    path: '/Order',
    name: 'orderlist',
    component: Orderlist,
    meta: {
      title: '订单列表',
      keepAlive: true,
    },
  },
  {
    path: '/Order/orderdetail/:id/',
    name: 'orderdetail',
    component: Orderdetail,
    meta: {
      title: '订单详情',
    },
  },
  {
    path: '/Appointment/:number',
    name: 'appointment',
    component: AppointmentIndex,
    meta: {
      title: '提货预约',
    },
  },
  {
    path: '/Appointmentxh/:number',
    name: 'appointmentxh',
    component: AppointmentxhIndex,
    meta: {
      title: '卸货预约',
    },
  },
  {
    path: '/Appointmentold',
    name: 'appointmentold',
    component: AppointmentIndex,
    meta: {
      title: '提货预约',
    },
  },
  {
    path: '/Appointmentxhold',
    name: 'appointmentxhold',
    component: AppointmentxhIndex,
    meta: {
      title: '卸货预约',
    },
  },
  {
    path: '/protocol',
    name: 'protocol',
    component: UserProtocol,
    meta: {
      title: '预约排队提货守则',
    },
  },
  {
    path: '/userprotocol',
    name: 'userprotocol',
    component: UserProtocol2,
    meta: {
      title: '预约排队提货守则',
    },
  },
  {
    path: '/appointmentxy/:from',
    name: 'appointmentxy',
    component: Appointmentxy,
    meta: {
      title: '协议',
    },
  },
  {
    path: '/uploadth/:id/',
    name: 'uploadth',
    component: Uploadth,
    meta: {
      title: '协议',
    },
  },
  {
    path: '/travelupload/',
    name: 'travelupload',
    component: Travelupload,
    meta: {
      title: '行程卡',
    },
  },
  //new
  {
    path: '/Mine',
    name: 'mine',
    component: Mine,
    meta: {
      title: '我的',
    },
  },
  {
    path: '/driverList',
    name: 'driverList',
    component: DriverList,
    meta: {
      title: '驾驶员管理',
    },
  },
  {
    path: '/adddriver',
    name: 'addDriver',
    component: AddDriver,
    meta: {
      title: '添加驾驶员',
    },
  },
  {
    path: '/driverDetail/:id',
    name: 'driverDetail',
    component: DriverDetail,
    meta: {
      title: '驾驶员详情',
    },
  },
  {
    path: '/editDriver/:id',
    name: 'editDriver',
    component: EditDriver,
    meta: {
      title: '编辑驾驶员',
    },
  },
  {
    path: '/escortList',
    name: 'escortList',
    component: EscortList,
    meta: {
      title: '押送员管理',
    },
  },
  {
    path: '/addEscort',
    name: 'addEscort',
    component: AddEscort,
    meta: {
      title: '添加押送员',
    },
  },
  {
    path: '/escortDetail/:id',
    name: 'escortDetail',
    component: EscortDetail,
    meta: {
      title: '押送员详情',
    },
  },
  {
    path: '/editEscort/:id',
    name: 'editEscort',
    component: EditEscort,
    meta: {
      title: '编辑押送员',
    },
  },
  {
    path: '/chetouList/',
    name: 'chetouList',
    component: ChetouList,
    meta: {
      title: '车头信息管理',
    },
  },
  {
    path: '/cheguaList/',
    name: 'cheguaList',
    component: CeguaList,
    meta: {
      title: '车头信息管理',
    },
  },
  {
    path: '/addchetou',
    name: 'addchetou',
    component: Addchetou,
    meta: {
      title: '新增车头备案',
    },
  },
  {
    path: '/editChetou/:id/',
    name: 'editChetou',
    component: EditChetou,
    meta: {
      title: '编辑车头备案',
    },
  },
  {
    path: '/addchegua',
    name: 'addchegua',
    component: Addchegua,
    meta: {
      title: '新增车挂备案',
    },
  },

  {
    path: '/chetouDetail/:id/',
    name: 'chetouDetail',
    component: ChetouDetail,
    meta: {
      title: '车头详情',
    },
  },
  {
    path: '/cheguaDetail/:id/',
    name: 'cheguaDetail',
    component: CheguaDetail,
    meta: {
      title: '车挂详情',
    },
  },
  {
    path: '/editChegua/:id/',
    name: 'editChegua',
    component: EditChegua,
    meta: {
      title: '编辑车挂备案',
    },
  },
  {
    path: '/uploadHealthCode/:id/',
    name: 'uploadHealthCode',
    component: UploadHealthCode,
    meta: {
      title: '上传核酸结果',
    },
  },
  {
    path: '/uploadPound/:id/:isSpecified/:chetouhao',
    name: 'uploadPound',
    component: UploadPound,
    meta: {
      title: '上传卸货磅单',
    },
  },
  {
    path: '/input-yy-number/:type/',
    name: 'inputYyNumber',
    component: InputYyNumber,
    meta: {
      title: '上传预约数量',
    },
  },
  {
    path: '/input-yy-number/:type/',
    name: 'inputYyNumberOld',
    component: InputYyNumberOld,
    meta: {
      title: '上传预约数量',
    },
  },
  {
    path: '/Appointmentnew/:number/:yyrq',
    name: 'appointmentnew',
    component: AppointmentIndexNew,
    meta: {
      title: '提货预约',
    },
  },
  {
    path: '/Appointmentxhnew/:number/:yyrq/:xhdh/:qfh',
    name: 'appointmentxhnew',
    component: AppointmentxhIndexNew,
    meta: {
      title: '卸货预约',
    },
  },
  {
    path: '/choice-th/:number/:yyrq',
    name: 'choiceThyy',
    component: ChoiceYy,
    meta: {
      title: '选择预约信息',
    },
  },
  {
    path: '/clear-cache',
    name: 'clearCache',
    component: ClearCache,
    meta: {
      title: '清除登录信息',
    },
  },
  {
    path: '/ai-chat',
    name: 'aiChat',
    component: AIChatIndex,
    meta: {
      title: '智能对话',
    },
  },
];

export default router;
